import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import Header from '@components/Header/Header'
import ServiceGrid from '@components/ServiceGrid/ServiceGrid'
import Provider from '@components/Provider/Provider'
import {
  Container,
  ContentContainer,
  SectionLabel,
  ProviderWrapper,
  ProviderLabel
} from './InternetCableTV.styles'

type ProviderType = {
  id: string
  name: string
  iconUrl: string
}

const InternetCableTV = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const providers: ProviderType[] = [
    {
      id: 'indihome',
      name: 'Indihome',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/IndiHome.svg'
    },
    {
      id: 'my-republic',
      name: 'My Republic',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/MyRepublic.svg'
    },
    {
      id: 'first-media',
      name: 'First Media',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/FirstMedia.svg'
    },
    {
      id: 'xl-satu',
      name: 'XL Satu',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/XLSatu.svg'
    },
    {
      id: 'biznet',
      name: 'Biznet',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/Biznet.svg'
    },
    {
      id: 'cbn',
      name: 'CBN',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/CBN.svg'
    },
    {
      id: 'centrin-online',
      name: 'Centrin Online',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/CentrinOnline.svg'
    },
    {
      id: 'globalxtreme',
      name: 'GlobalXtreme',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/GlobalXtreme.svg'
    },
    {
      id: 'mnc-vision',
      name: 'MNC Vision',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/MNCVision.svg'
    },
    {
      id: 'k-vision',
      name: 'K Vision',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/KVision.svg'
    },
    {
      id: 'indosat-hifi',
      name: 'Indosat HiFi',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/IndosatHifi.svg'
    },
    {
      id: 'okevision',
      name: 'Okevision',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/OkeVision.svg'
    },
    {
      id: 'skynindo-tv',
      name: 'Skynindo TV',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/SkyIndo.svg'
    },
    {
      id: 'top-tv',
      name: 'TOP TV',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/TopTv.svg'
    },
    {
      id: 'transvision',
      name: 'Transvision',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/TransVision.svg'
    },
    {
      id: 'wifi-id',
      name: 'Wifi.id',
      iconUrl: 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/other_providers/WifiId.svg'
    },
  ]

  const handleProviderClick = (provider: ProviderType) => {
    navigate('/internet-cable-tv-detail', { state: { provider } })
  }

  return (
    <Container>
      <Header
        title={t('internetCableTV.header')}
        showBackButton={true}
        onBackClick={() => navigate(-1)}
      />
      <ContentContainer>
        <SectionLabel>{t('internetCableTV.selectProvider')}</SectionLabel>
        <ServiceGrid columns={4}>
          {providers.map((provider) => (
            <ProviderWrapper key={provider.id} onClick={() => handleProviderClick(provider)}>
              <Provider iconUrl={provider.iconUrl} />
              <ProviderLabel>{provider.name}</ProviderLabel>
            </ProviderWrapper>
          ))}
        </ServiceGrid>
      </ContentContainer>
    </Container>
  )
}

export default InternetCableTV
